module.exports = __webpack_public_path__ + "img/hr-green-pita-mini-04.23049094.png";